import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-mobile',
  templateUrl: './app-mobile.component.html',
  styleUrls: ['./app-mobile.component.scss']
})
export class AppMobileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
